import React, { useState } from "react"
import Tabs from "../../../../../components/common/Tabs/Tabs"
import All from "./All/All"
import Pending from "./Pending/Pending"
import Processing from "./Processing/Processing"
import Shipped from "./Shipped/Shipped"
import Intransit from "./Intransit/Intransit"
import Delivered from "./Delivered/Delivered"
import DynamicDropdown from "../../../../../components/common/SellerCommonComponents/DynamicDropdown/DynamicDropdown"

const TrackingAndUpdates = () => {
  const tabs = ["All", "Pending", "Processing", "Shipped", "In transit", "Delivered"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  const printDropdownOptions = [
    { label: "Print invoices of selected items", action: () => console.log("print group") },
    { label: "Print shipping labels for selected items", action: () => console.log("print group") },
    { label: "Print stock checklist for selected items", action: () => console.log("print group") },
  ]

  const exportDropdownOptions = [
    { label: "Export all orders", action: () => console.log("export group") },
    { label: "Export all selected orders", action: () => console.log("export group") },
    { label: "Export all pending orders", action: () => console.log("export group") },
    { label: "Export all ready to ship orders", action: () => console.log("export group") },
    { label: "Export all shipped orders", action: () => console.log("export group") },
    { label: "Export all delivered orders", action: () => console.log("export group") },
    { label: "Export all cancelled orders", action: () => console.log("export group") },
    { label: "Export all returned orders", action: () => console.log("export group") },
    { label: "Export all refund only orders", action: () => console.log("export group") },
    { label: "Export all failed delivery orders", action: () => console.log("export group") },
  ]

  const viewHistoryOptions = [
    { label: "Today", action: () => console.log("Viewing history for Today") },
    { label: "Yesterday", action: () => console.log("Viewing history for Yesterday") },
    { label: "Last 7 days", action: () => console.log("Viewing history for Last 7 days") },
    { label: "Last month", action: () => console.log("Viewing history for Last month") },
  ]

  return (
    <div>
      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab}>
        <div className="d-flex gap-2">
          <DynamicDropdown placeholder="Print" options={printDropdownOptions} />
          <DynamicDropdown placeholder="Export" options={exportDropdownOptions} />
          <DynamicDropdown placeholder="View History" options={viewHistoryOptions} />
        </div>
      </Tabs>

      {activeTab === "All" && <All />}
      {activeTab === "Pending" && <Pending />}
      {activeTab === "Processing" && <Processing />}
      {activeTab === "Shipped" && <Shipped />}
      {activeTab === "In transit" && <Intransit />}
      {activeTab === "Delivered" && <Delivered />}
    </div>
  )
}

export default TrackingAndUpdates
